<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="500">
        <v-card>
            <v-card-title class="headline">Compartir material</v-card-title>
            <v-card-text>
                <p>Comparte <strong>{{ documentName }}</strong> con tus compañeros:</p>

                <div 
                v-if="false"
                class="mt-4">
                    <p class="font-weight-medium mb-2">Compartir por Email:</p>
                    <v-text-field v-model="shareEmail" label="Email para compartir" outlined type="email"></v-text-field>

                    <!-- Lista de correos a los que se ha compartido -->
                    <div v-if="sharedEmails.length > 0" class="mt-4">
                        <p class="font-weight-medium mb-2">Compartido con:</p>
                        <v-chip-group column>
                            <v-chip v-for="email in sharedEmails" :key="email" small outlined>
                                {{ email }}
                            </v-chip>
                        </v-chip-group>
                    </div>

                    <v-btn color="primary" class="mt-2 primary"
                    style="padding-left: 34px !important; padding-right: 34px !important;"
                    :disabled="!shareEmail" @click="sendShareEmail">
                        Enviar
                    </v-btn>
                </div>

                <v-divider 
                v-if="false"
                class="my-10"></v-divider>

                <div class="mt-4 mb-5">
                    <p class="mb-2">Cualquier persona con este enlace puede ver el material:</p>
                    <v-text-field
                        :value="documentUrl"
                        label="Enlace del material"
                        readonly
                        outlined
                        append-icon="mdi-content-copy"
                        @click:append="copyUrlToClipboard"
                        ref="urlField"
                    ></v-text-field>
           
                    <v-snackbar v-model="copySuccess" :timeout="2000" color="primary" bottom>
                        Enlace copiado
                    </v-snackbar>
                </div>
            </v-card-text>

            <v-icon class="close-icon" @click="closeDialog" >mdi-close</v-icon>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ShareDocumentDialog',
    props: {
        value: { // Controls dialog visibility (v-model)
            type: Boolean,
            required: true
        },
        documentId: {
            type: [String, Number],
            required: true
        },
        documentName: {
            type: String,
            default: 'este material'
        }
    },
    data() {
        return {
            shareEmail: '',
            sharedEmails: [],
            copySuccess: false
        };
    },
    computed: {
        documentUrl() {
            // Asegúrate que la URL base es correcta para tu entorno
            const baseUrl = window.location.origin;
            return `${baseUrl}/app/document/${this.documentId}`;
        }
    },
    watch: {
        value(newValue) {
            // Load shared emails when the dialog opens
            if (newValue && this.documentId) {
                this.loadSharedEmails();
            } else {
                // Reset when closing
                this.shareEmail = '';
                this.sharedEmails = [];
                this.copySuccess = false;
            }
        }
    },
    methods: {
        async loadSharedEmails() {
            if (!this.documentId) return;
            try {
                const response = await this.axios.get(`/documents/${this.documentId}/shared-with`, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                });

                if (response.data.success) {
                    this.sharedEmails = response.data.sharedWith || [];
                } else {
                    this.sharedEmails = [];
                    console.error('Error al cargar los destinatarios compartidos:', response.data.error);
                    // Optionally show a toast error
                }
            } catch (err) {
                this.sharedEmails = [];
                console.error('Error al cargar los destinatarios compartidos:', err);
                 // Optionally show a toast error
            }
        },

        async sendShareEmail() {
            if (!this.shareEmail || !this.documentId) return;

            try {
                const response = await this.axios.post('/documents/share', {
                    documentId: this.documentId,
                    email: this.shareEmail
                }, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                });

                if (response.data.success) {
                    this.$toast.success('Material compartido exitosamente');
                    this.shareEmail = ''; // Clear input after sending
                    await this.loadSharedEmails(); // Refresh the list
                } else {
                    this.$toast.error(response.data.error || 'No se pudo compartir el material');
                }
            } catch (err) {
                console.error('Error al compartir el material:', err);
                this.$toast.error('Error al compartir el material');
            }
        },

        async copyUrlToClipboard() {
            try {
                await navigator.clipboard.writeText(this.documentUrl);
                this.copySuccess = true;
                 // Opcional: mostrar un toast de éxito
                 // this.$toast.success('Enlace copiado al portapapeles');
            } catch (err) {
                console.error('Error al copiar la URL:', err);
                // Opcional: mostrar un toast de error
                // this.$toast.error('No se pudo copiar el enlace');
            }
        },

        closeDialog() {
            this.$emit('input', false);
        }
    }
};
</script>

<style scoped>
/* Add any specific styles for the dialog if needed */
.primary {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 600 !important;
    font-size: 0.95rem !important;
    border-radius: 12px !important;
    transition: filter 0.2s ease, transform 0.1s ease !important;
    border: 1px solid #4dd453 !important;
    height: 38px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
    background-color: #4dd453 !important;
    box-shadow: 0 4px 0 #42b848 !important;
    color: white !important;
}

.primary.v-btn--disabled {
    opacity: 0.8;
    cursor: not-allowed;
    border: 1px solid #c9c9c9 !important;
    box-shadow: 0 4px 0 #c1c1c1 !important;
    border-radius: 12px !important;
}

.close-icon {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
}

.close-icon:hover {
    color: #4dd453 !important;
}
</style> 